/* eslint-disable react/jsx-boolean-value */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui';
import VisuallyHiddenLegend from '@components/shared/visually-hidden-legend';
import ControlLabel from './control-label';
import './form.scss';

const ToggleControl = ({ describedBy, disabled, legend, name, onChange, value }) => {
  // The value is the 'true' string, thus convert to boolean with ===.
  const handleChange = useCallback(event => onChange(event.target.value === 'true'), [onChange]);

  return (
    <div styleName="control-container toggle-control">
      <FormControl component="fieldset" {...(describedBy ? { 'aria-describedby': describedBy } : {})}>
        {legend && <VisuallyHiddenLegend>{legend}</VisuallyHiddenLegend>}
        <RadioGroup
          row
          // Must be unique per instance - multiple ToggleControls on one page sharing a
          // native radio 'name' puts them all in the same native group, so selecting one
          // silently unchecks the others' radios at the DOM level (input_checkboxes_grouped).
          name={name}
          value={value}
          onChange={handleChange}
        >
          <FormControlLabel
            control={<Radio color="primary" disabled={disabled} size="small" />}
            label={<ControlLabel disabled={disabled} label="Yes" />}
            value={true}
          />
          <FormControlLabel
            control={<Radio color="primary" disabled={disabled} size="small" />}
            label={<ControlLabel disabled={disabled} label="No" />}
            value={false}
          />
        </RadioGroup>
      </FormControl>
    </div>
  );
};

ToggleControl.propTypes = {
  describedBy: PropTypes.string,
  disabled: PropTypes.bool,
  legend: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.bool
};

export default ToggleControl;
